import Confirmation2FA from './Confirmation2FA';

export default Confirmation2FA;
